import { Instagram, Facebook } from "lucide-react";


export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1A2E22] pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 pb-10 border-b border-white/10">
          <div className="max-w-md">
            <p className="font-heading text-2xl font-bold text-[#74C69D] mb-2">Takomst fan Menaam</p>
            <p className="font-heading italic text-base text-[#FAF7F2]/60 mb-2">Mei elkoar, foar elkoar.</p>
            <p className="text-sm text-[#FAF7F2]/50 leading-relaxed m-0 mb-4">
              Werkgroep Toekomst Accommodaties · Menaam, gemeente Waadhoeke
            </p>
            <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
              <a
                href="https://www.instagram.com/takomstmenaam/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                aria-label="Volg Takomst fan Menaam op Instagram"
                className="inline-flex items-center gap-2 text-sm text-[#FAF7F2]/70 hover:text-[#74C69D] transition-colors"
              >
                <Instagram size={16} /> @takomstmenaam
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61591858686559"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                aria-label="Volg Takomst fan Menaam op Facebook"
                className="inline-flex items-center gap-2 text-sm text-[#FAF7F2]/70 hover:text-[#74C69D] transition-colors"
              >
                <Facebook size={16} /> Facebook
              </a>
            </div>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-2">
            {["Situatie", "Planning", "Ideeën", "Meedoen", "Contact"].map((l) => (
              <a
                key={l}
                href={`#${l.toLowerCase().replace("ë", "e")}`}
                className="text-sm text-[#FAF7F2]/55 hover:text-[#74C69D] transition-colors"
              >
                {l}
              </a>
            ))}
          </nav>
        </div>

        <p className="mt-8 text-xs text-[#FAF7F2]/35 leading-relaxed max-w-2xl">
          takomstmenaam.nl · Deze website informeert over de stand van zaken. De inhoud
          weerspiegelt geen definitieve besluiten.
        </p>

        <p
          aria-hidden="true"
          className="select-none font-heading font-black text-[#FAF7F2]/5 leading-none mt-10 tracking-tighter text-[18vw] lg:text-[15vw]"
        >
          Menaam
        </p>
      </div>
    </footer>
  );
}
